@if (showDot()) {
  <div class="dot"></div>
}
<div class="wrapper-label">
  @if (showIcon()) {
    <ui-icon faName="info-circle" faStyle="light"></ui-icon>
  }

  <span>Maximal {{ maxOrderCount() }}
    @if (maxOrderCount() > 1) {
      Pakete
    } @else {
      Paket
    }
    
    pro Kunde</span>
</div>
